import { API_URL as api } from "@/config/env";

export const urls = {
	userCountries: `${api}GetUserCountries?`,
	groupStatus: `${api}PGCGApproval/GetStatus`,
	periods: `${api}PGCGApproval/GetPeriods`,
	productGroups: `${api}ProductGroup/GetProductGroupsWithStatus`,
	customerGroups: `${api}CustomerGroup/GetCstmrGrpWithStatus`,
	rejectApproveProductGroup: `${api}ProductGroup/ApproveProductGroup`,
   rejectApproveCustomerGroup: `${api}CustomerGroup/ApproveCstmrGrp`,
   approveRejectMultiPG: `${api}ProductGroup/ApproveProductMultiple`,
   approveRejectMultiCG: `${api}CustomerGroup/ApproveCustomerMultiple`,
};

export const views = [
	{ key: 1, value: "Product Group" },
	{ key: 2, value: "Customer Group" },
];

export function getProductGroupsTable(data) {
	const rows = getProductGroupsRow(data);
	for(let i = 0; i < rows.length; i++) {
		rows[i] = getApproveStatus(rows[i]);
	}
	return { rows };
}

function getProductGroupsRow(data) {
	return data.map((item) => {
		return {
			id: item.productGroupID,
			productGroupName: item.productGroupName,
			countryCode: item.countryCode,
			status: item.status,
			updatedDate: item.updatedDate,
			updatedBy: item.updatedBy,
		};
	});
}

export function getCustomerGroupsTable(data) {
	const rows = getCustomerGroupsRow(data);
	for(let i = 0; i < rows.length; i++) {
		rows[i] = getApproveStatus(rows[i]);
	}
	return { rows };
}


function getCustomerGroupsRow(data) {
	return data.map((item) => {
		return {
			id: item.customerGroupID,
			customerGroupName: item.customerGroupName,
			countryCode: item.countryCode,
			status: item.status,
			updatedDate: item.updatedDate,
			updatedBy: item.updatedBy,
		};
	});
}


function getApproveStatus (item){
	let groupStatus = item.status.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		if (groupStatus == "submitted" || groupStatus == "locally approved" 
			|| groupStatus == "submitted – approved and modified" 
			|| groupStatus == 'locally approved – approved and modified'){
				item['canApproveReject'] = false;
				item['canEdit']=false;
			}
	}
	else{
		if (groupStatus == "approved" || groupStatus == "rejected"){
				item['canApproveReject'] = false;
				item['canEdit']=true;
		}
		else{
			if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))){
				if (groupStatus == "submitted" || groupStatus == "locally approved" || groupStatus == "submitted – approved and modified" 
					|| groupStatus == 'locally approved – approved and modified'){
						item['canApproveReject'] = true;
						item['canEdit']=false;
					}
			}
			else if (!logedUser.isHQUser){
				if (groupStatus == "submitted" || groupStatus == "submitted – approved and modified"){
						item['canApproveReject'] = true;
						item['canEdit']=false;
				}
				else if(groupStatus == "locally approved"){
						item['canApproveReject'] = false;
						item['canEdit']=false;
				}
			}
		}
	}
	return item;
}
